import { render } from "./WhatsUpModal.vue?vue&type=template&id=7bd450fe"
import script from "./WhatsUpModal.vue?vue&type=script&lang=js"
export * from "./WhatsUpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__